<!-- Omni Components will get loaded here -->
<ng-container *cignaFeatureToggle="'generalChat'">
  <!-- <cigna-omni-interceptions-data></cigna-omni-interceptions-data> -->
  <cigna-omni-chat-shell></cigna-omni-chat-shell>
  <cigna-omni-chat-bubble-data
    [isLiveChatAvailable]="liveChatAvailable$ | async"
  ></cigna-omni-chat-bubble-data>
  <cigna-omni-fancy-invitation-data></cigna-omni-fancy-invitation-data>
</ng-container>
